import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Button,
  Form,
  Badge,
} from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import BlogImage from "../../assest/image/Portfolio/Social/Social (1).jpg";
import "../../assest/css/Fullblog.css";
import Footer from "../Footer/Footer";
import Apiurl from "../environments/Apiurl";
import { FaSearch } from "react-icons/fa";

const FullBlog = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);
  const [recentPosts, setRecentPosts] = useState([]);

  // Fetch single blog
  useEffect(() => {
    const fetchBlog = async () => {
      if (!id) {
        setLoading(false);
        return;
      }
      try {
        const response = await axios.get(`${Apiurl}/blog/blog-card/${id}`);
        setBlog(response.data);
      } catch (error) {
        console.error("Error fetching blog:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchBlog();
  }, [id]);

  // Fetch recent posts
  useEffect(() => {
    const fetchRecentPosts = async () => {
      try {
        const response = await axios.get(`${Apiurl}/blog/blog-card`);
        const allBlogs = response.data.blogs || [];
        const sortedRecent = allBlogs
          .sort((a, b) => new Date(b.post_date) - new Date(a.post_date))
          .slice(0, 3);
        setRecentPosts(sortedRecent);
      } catch (error) {
        console.error("Error fetching recent posts:", error);
      }
    };
    fetchRecentPosts();
  }, []);

  // Clean up the cover_image URL to fix case sensitivity (Uploads vs uploads) and extra slashes
  const cleanImageUrl = (url) => {
    if (!url) return BlogImage;
    // Normalize Uploads to uploads for consistency, remove double slashes
    return url
      .replace(/^\/+/, '') // Remove leading slashes
      .replace(/uploads/i, 'uploads') // Ensure lowercase 'uploads'
      .replace(/\/uploads\/+uploads\//i, '/uploads/') // Fix double uploads if any
      .replace(/^(.*\/)uploads\//i, '$1uploads/'); // Ensure single uploads
  };

  if (loading) {
    return (
      <Container fluid className="py-5">
        <Row className="justify-content-center">
          <Col lg={8}>
            <div className="text-center">Loading blog...</div>
          </Col>
        </Row>
      </Container>
    );
  }

  if (!blog) {
    return (
      <Container fluid className="py-5">
        <Row className="justify-content-center">
          <Col lg={8}>
            <div className="text-center">Blog not found.</div>
          </Col>
        </Row>
      </Container>
    );
  }

  // Fallback to hardcoded image if no blog image
  const blogImage = cleanImageUrl(blog.cover_image) || BlogImage;

  return (
    <>
      {/* Hero Section */}
 
      <div className="Blog-hero">
        <div className="about-content text-center">
          <div className="hero-title-container">
            <span className="badge-title">Blog</span>
            <h1 className="text-white fw-bold">Insights & Updates</h1>
            <p className="text-light">
              Latest articles on tech, design, and innovation.
            </p>
          </div>
        </div>
      </div>

      {/* Blog Section */}

      <Container>
        <section className="blog-page py-5">
        <Container fluid>
          <Row>
            {/* Main Blog Content */}
            <Col lg={8} className="mb-4">
              <Card className="blog-container shadow-lg border-0 rounded-4">
                <Card.Body className="p-5">
                  {/* Blog Header */}
                  <div className="blog-header text-start mb-4">
                    <span className="category-badge mb-3">{blog.category}</span>
                    <h1 className="blog-title mb-3">
                      {blog.blog_title || "Untitled Blog"}
                    </h1>
                    <div className="blog-meta mb-3">
                      <span className="me-4">
                        <i className="bi bi-calendar me-2"></i>{" "}
                        {blog.post_date || "Unknown Date"}
                      </span>
                      <span>
                        <i className="bi bi-person me-2"></i> By Aalan TechSoft
                      </span>
                    </div>
                    {/* <p className="blog-intro text-muted">
                      {blog.blog_para ||
                        "No introduction available for this blog."}
                    </p> */}
                  </div>

                  {/* Banner Image */}
                  <div className="blog-banner mb-5">
                    <img
                      src={blogImage}
                      alt={blog.blog_title || "Blog Banner"}
                      className="img-fluid w-100 rounded-3 shadow-sm"
                    />
                  </div>

                  {/* Blog Content - Render as HTML for dynamic content */}
                  <div
                    className="blog-content"
                    dangerouslySetInnerHTML={{ __html: blog.text_editor || "" }}
                  />
                </Card.Body>
              </Card>

              {/* Subscribe */}
              {/* <Card className="shadow-sm border-0 mt-4 rounded-4">
                <Card.Body className="p-5">
                  <h5 className="fw-bold mb-3">Subscribe</h5>
                  <p className="text-muted mb-4">
                    Get the latest posts delivered right to your inbox
                  </p>

                  <div className="row">

                    <div className="col-8"><Form.Group className="mb-3">
                    <Form.Control
                      type="email"
                      placeholder="Your email address"
                      className="rounded-pill"
                    />
                  </Form.Group></div>
                    <div className="col-4"><Button className="cta-btn px-4 py-2 rounded-2 w-100">
                    Subscribe
                  </Button></div>



                  </div>
                  
                  
                </Card.Body>
              </Card> */}
            </Col>

            {/* Sidebar with Recent Posts */}
            <Col lg={4} md={12} className="sidebar mt-4 mt-lg-0">
              {/* Recent Posts */}
              <div className="sidebar-box">
                <h5 className="sidebar-title">Recent Posts</h5>
                <ul className="recent-list">
                  {recentPosts.map((post) => (
                    <li
                      key={post._id}
                      className="recent-item"
                      onClick={() => navigate(`/fullblog/${post._id}`)}
                      style={{ cursor: "pointer" }}
                    >
                      <img
                        src={cleanImageUrl(post.cover_image)}
                        alt={post.blog_title}
                        className="recent-thumb"
                        onError={(e) => { e.target.src = BlogImage; }}
                      />
                      <div>
                        <p className="recent-title">{post.blog_title}</p>
                        <small className="text-muted">{post.post_date}</small>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      
      </Container>
      

      {/* Footer */}
      <Footer />
    </>
  );
};

export default FullBlog;